/**
 * Label for the synthetic "show all / go to this category" link under a Handla category.
 * Preserves the category name casing from the menu.
 */
export const formatShowAllCategoryLabel = (name: string): string => `Allt i ${name}`;
